module.exports = __webpack_public_path__ + "static/banner3-51f877fbe019ebdae5447bba0d08f86c.jpg";